import React from "react";
export const AmyLuk = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="amyLukkenModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/amylukken.jpg"
                    alt="Amy Lukken"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Amanda Jane (Amy) Lukken
                    </h4>
                    <p>
                      <strong>Joyologist @ Large</strong>
                    </p>
                    <p style={{ paddingTop: "em" }}>
                      <strong>
                        “Choose to be happy, love and joy are the inevitable
                        result”
                      </strong>
                    </p>
                  </div>
                  <div className="modal-body-container">
                    <p>
                      After 15 years as an executive at a Fortune 500 company
                      Amy arrived at a truth which would shape the rest of her
                      life and the lives of all those around her…
                    </p>
                    <p>
                      People are the number one asset in any company AND
                      managing that asset is the most complex component of any
                      business.
                    </p>
                    <p>
                      This revelation coupled with a seminal life event,
                      inspired Amy to partner with Gallup’s world-renowned
                      behavioral scientists. Together, paying special attention
                      to what most intensely motivates and inspires people, they
                      looked at “feeling-sets”, which included love and joy and
                      its extraordinary impact on employee satisfaction,
                      efficiency, productivity, and the bottom line.
                    </p>
                    <p>
                      Amy became convinced that business could revolutionize
                      itself simply by applying these two “seemingly
                      un-businesslike emotions to their culture just as she had
                      applied them to herself and her work life.
                    </p>
                    <p>
                      One afternoon, a senior executive who worked with Amy
                      approached her at the end of a meeting and said, “I know
                      what you are, you’re a Joyologist! “ And so she is.
                    </p>
                    <p>
                      Ms Lukken has practiced the skills she learned working as
                      a Certified Strengths Coach, and sees how natural and
                      powerful it is when the focus stays on what's good within
                      people versus emphasizing their weaknesses and failures.
                    </p>
                    <p>The result is a rush of joy that is automatic.</p>
                    <p>
                      Currently co-creating a culture of love and joy at Tito's
                      Handmade Vodka as Chief Joyologist and Director of
                      Philanthropy, Ms Lukken is available for select
                      engagements in partnership with Big Blue Fish, “cause
                      workin’ together is just so damn much fun!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
